/**
*
* Map
*
*/

import React from 'react';


import throttle from 'helpers/throttle';

import { MAPBOX_TOKEN } from 'configs';


import MapWrapper from './styles/MapWrapper';


class Map extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function

  constructor() {
    super();

    this.thisMap = React.createRef();
    
    this._isMounted = false;

    this.onViewportChange = this.onViewportChange.bind(this);

    this.state = {
      viewport: {
        latitude: 37.7577,
        longitude: -122.4376,
        zoom: 15
      }
    };
  }
  

  onViewportChange = throttle((viewport, hasTimeout) => {
    if (!this._isMounted || !this.thisMap || !this.thisMap.current) return;

    const thisViewport = viewport ? { ...this.state.viewport, ...viewport } : this.state.viewport;

    if (hasTimeout) return setTimeout(() => {
      if (!this._isMounted || !this.thisMap) return;
      this.setState({
        viewport: thisViewport,
        width: this.thisMap.current.parentNode.getBoundingClientRect().width,
        height: this.thisMap.current.parentNode.getBoundingClientRect().height
      });
    }, 300);

    this.setState({
      viewport: thisViewport,
      width: this.thisMap.current.parentNode.getBoundingClientRect().width,
      height: this.thisMap.current.parentNode.getBoundingClientRect().height
    });

  }, 17);



  componentDidMount() {

    this._isMounted = true;

    const {
      frameRef,
    } = this.props;

    const frameWindow = frameRef && document.querySelector(frameRef) && document.querySelector(frameRef).contentWindow ? document.querySelector(frameRef).contentWindow : window;


    const viewport = {};

    if (this.props.viewport && this.props.viewport.type === 'Point' && this.props.viewport.coordinates) {

      viewport.longitude = this.props.viewport.coordinates[0];
      viewport.latitude = this.props.viewport.coordinates[1];

    }

    if (this.props.viewport && this.props.viewport.longitude && this.props.viewport.latitude) {

      viewport.longitude = this.props.viewport.longitude;
      viewport.latitude = this.props.viewport.latitude;

    }

    this.setState(viewport);





    frameWindow.addEventListener('resize', this.onViewportChange);    
   


  }
  
  componentDidUpdate(prevProps, prevState) {
    const { windowWidth } = this.props;

    if (prevProps.windowWidth !== windowWidth) return this.onViewportChange(null, true);

    let latitude;
    let longitude;



    if (this.props.viewport && this.props.viewport.type === 'Point' && this.props.viewport.coordinates) {

      longitude = this.props.viewport.coordinates[0];
      latitude = this.props.viewport.coordinates[1];

    }

    if (this.props.viewport && this.props.viewport.longitude && this.props.viewport.latitude) {

      longitude = this.props.viewport.longitude;
      latitude = this.props.viewport.latitude;

    }


    if (!latitude || !longitude) return;

    if (
      latitude !== prevState.viewport.latitude ||
      longitude !== prevState.viewport.longitude
    ) {
      const viewport = {
        latitude: latitude,
        longitude: longitude
      };
      this.onViewportChange(viewport);
    }


  }


  componentWillUnmount() {
    this._isMounted = false;

    const {
      frameRef
    } = this.props;

    const frameWindow = frameRef && document.querySelector(frameRef) && document.querySelector(frameRef).contentWindow ? document.querySelector(frameRef).contentWindow : window;

    frameWindow.removeEventListener('resize', this.onViewportChange);

  }


  render() {
    const { 
      width, 
      height, 
      viewport 
    } = this.state;

    const {
      place_id
    } = this.props;

    const {
      latitude,
      longitude,
      zoom
    } = viewport;

    

    return(
      <a href={place_id ? `https://www.google.com/maps/search/?api=1&query=Google&query_place_id=${place_id}` : `http://www.google.com/maps/place/${latitude},${longitude}`} target="_blank">
        <MapWrapper
          ref={this.thisMap}
          theme={this.props.theme}
          width={width}
          height={height}
          background={`https://api.mapbox.com/styles/v1/mapbox/light-v10/static/geojson(%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B${longitude}%2C${latitude}%5D%7D)/${longitude},${latitude},${zoom}/${width > 800 ? '1280x1280' : '800x800'}?access_token=${MAPBOX_TOKEN}`}
        >
        </MapWrapper>
      </a>
      
    );
  }
}

export default Map;
